import { SaveEntityBasedDynamicProcessModelFormInModal } from "../../features/save-entity-based-dynamic-process-model";
import { useTranslations } from "use-intl";
import { AddButtonGroup } from "@/shared/form/button/add-button-group/add-button-group";
import { SaveDynamicProcessModelInModal } from "../../features/save-dynamic-process-model";

export function AddDynamicProcess() {
  const t = useTranslations("DynamicProcesses");

  return (
    <AddButtonGroup
      buttonProps={{ children: t("Add dynamic process") }}
      popoverProps={{
        content: (
          <div>
            <SaveEntityBasedDynamicProcessModelFormInModal />
            <SaveDynamicProcessModelInModal />
          </div>
        ),
      }}
    />
  );
}
